import { makeStyles } from 'tss-react/mui';

export interface UseStylesParams {
  hasError: boolean;
  isSending: boolean;
  isMessageOfUser: boolean;
}

export const useTextMessageStyles = makeStyles<UseStylesParams>()(
  (theme, { hasError, isMessageOfUser, isSending }) => ({
    message: {
      borderRadius: '32px',
      padding: '6px 20px',
      backgroundColor: isMessageOfUser
        ? theme.palette.primary.main
        : theme.palette.background.default,
      color: isMessageOfUser ? theme.palette.common.white : theme.palette.text.primary,
      opacity: isSending || hasError ? 0.5 : 1,
    },
  }),
);
